import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import { TodaySection, VerifyListSection } from "./components/FeedSections";
import { TopicsSection, HotRankSection, TimelineSection } from "./components/ExtraSections";
import { FaqSection, AboutSection, SiteFooter } from "./components/InfoSections";
import JsonLd from "@/components/base/JsonLd";

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50 shadow-soft transition-all hover:bg-primary-600 ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line"></i>
    </button>
  );
}

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "吃瓜今天",
  alternateName: "吃瓜今天已实锤",
  url: "https://broadms.cn/",
  inLanguage: "zh-CN",
  description:
    "每日汇总已实锤的石锤合集与实锤名单，区分确认瓜、落地瓜与盖棺定论，先核实后收录、逐条标注信源。",
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "吃瓜今天",
  url: "https://broadms.cn/",
  logo: "https://broadms.cn/favicon.svg",
  contactPoint: {
    "@type": "ContactPoint",
    email: "hi@chigua-today.example",
    contactType: "customer service",
    availableLanguage: "zh-CN",
  },
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={orgSchema} />
      <Header />
      <main>
        <Hero />
        <TodaySection />
        <VerifyListSection />
        <TopicsSection />
        <HotRankSection />
        <TimelineSection />
        <FaqSection />
        <AboutSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}